const types = {
  GET_EMAILS_START: 'GET_EMAILS_START',
  GET_EMAILS_SUCCESS: 'GET_EMAILS_SUCCESS',
  GET_EMAILS_FAILURE: 'GET_EMAILS_FAILURE',

  GET_EMAIL_PREVIEW_SUCCESS: 'GET_EMAIL_PREVIEW_SUCCESS',

  RESET_EMAIL_PREVIEW: 'RESET_EMAIL_PREVIEW',

  UPLOAD_EMAIL_IMAGE_SUCCESS: 'UPLOAD_EMAIL_IMAGE_SUCCESS',

  CLEAR_EMAIL_IMAGE: 'CLEAR_EMAIL_IMAGE',
};
export default types;
